var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('property-form',{attrs:{"loading":_vm.loading,"propertyData":_vm.property,"formErrors":_vm.formErrors},on:{"propertySubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }